import { Button, Grid } from '@mui/material'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FetchPaginationItems } from '../../../UserData/_actions/UserDataActions'
import { AddRounded as AddRoundedIcon } from '@mui/icons-material'
import AddTaxNumberDialog from './AddTaxNumberDialog'
import TaxNumber from './TaxNumber'
import TaxNumberSkeleton from './TaxNumberSkeleton'
import { GetUserTaxNumbers } from '../../../UserData/_actions/UserTaxNumberActions'
import AccountHeader from '../../AccountHeader'
import { useAppDispatch } from '../../../Common/_hooks/useAppDispatch'
import { useAppSelector } from '../../../Common/_hooks/useAppSelector'
import { type UserTaxNumberStore } from '../../../UserData/_stores/UserTaxNumberStore'
import AccountEmptyCard from '../../AccountEmptyCard'

const LOADING_ITEM_COUNT = 6

export default function TaxNumberList() {
  const dispatch = useAppDispatch()
  const [t] = useTranslation('account-v2')

  const taxNumbers = useAppSelector(state => state.get('userData').get('taxNumbers'))
  const loading = useAppSelector(state => state.get('UIData').get('loaders').get('fetch_tax_numbers'))

  const [addDialogOpened, setAddDialogOpened] = useState(false)

  const loadingGrid = useMemo(() => {
    const listSkeletons = []

    for (let i = 0; i < LOADING_ITEM_COUNT; i++) {
      listSkeletons.push(<TaxNumberSkeleton key={i} />)
    }

    return listSkeletons
  }, [])

  useEffect(() => {
    const formData = new FormData()
    formData.append('offset', String(0))
    formData.append('limit', String(20))

    dispatch(FetchPaginationItems('tax-numbers', formData, 'addresses'))
    dispatch(GetUserTaxNumbers())
  }, [])

  const onAddOpen = useCallback(() => {
    setAddDialogOpened(true)
  }, [])

  const onAddClose = useCallback(() => {
    setAddDialogOpened(false)
  }, [])

  const renderTaxNumber = useCallback((taxNumber: UserTaxNumberStore) => {
    return <Grid item xs={12} md={6} lg={4} key={taxNumber.get('id')}>
      <TaxNumber taxNumber={taxNumber} />
    </Grid>
  }, [])

  return <>
    <AccountHeader
      title={t('Tax numbers')}
      actions={taxNumbers.count() > 0 ? <Button
        variant="contained"
        color="accent"
        startIcon={<AddRoundedIcon />}
        onClick={onAddOpen}
      >{t('Add Tax number')}</Button> : null}
    />

    <Grid container spacing={2}>
      {loading
        ? loadingGrid
        : taxNumbers.count() > 0
          ? taxNumbers.valueSeq().map(renderTaxNumber)
          : <Grid item xs={12} md={6} lg={4}>
            <AccountEmptyCard
              title={t('No tax numbers yet')}
              description={t('Add your business tax number so we can avoid charging those taxes when applicable.')}
              actionLabel={t('Add Tax number')}
              onAction={onAddOpen}
            />
          </Grid>}
    </Grid>

    <AddTaxNumberDialog
      opened={addDialogOpened}
      onClose={onAddClose}
    />
  </>
}
